import { getProtected } from './utils';

export var getGroups = function getGroups(playerSessionID) {
  return getProtected('/player-groups', playerSessionID);
};

export default {
  getGroups: getGroups
};